/**
 * EditSummaryItemModal Router
 *
 * Routes to the appropriate edit modal based on product type:
 * - Activity: EditActivityModal (timeslot, timepoint, days, nights)
 * - Package: EditPackageModal
 * - Accommodation: EditAccommodationModal (Visbook accommodation API only)
 */

import { CartItem } from '@repo/types';
import { EditActivityModal } from './edit-modals/EditActivityModal';
import { EditPackageModal } from './edit-modals/EditPackageModal';
import { EditAccommodationModal } from './edit-modals/EditAccommodationModal';

import type { JSX } from 'react';

export default function EditSummaryItemModal(props: {
    anchorEl: HTMLElement | null;
    cartItem: CartItem;
    onClose: () => void;
}): JSX.Element {
    const { cartItem, anchorEl, onClose } = props;

    // Determine product type from cart item
    const productType = cartItem.products[0]?.product?.type;

    // Check if package by examining cartItem.pkg (packages are stored differently)
    const isPackage = !!cartItem.pkg;

    // Route to appropriate modal
    if (isPackage) {
        return <EditPackageModal cartItem={cartItem} anchorEl={anchorEl} onClose={onClose} />;
    }

    if (productType === 'accommodation') {
        return <EditAccommodationModal cartItem={cartItem} anchorEl={anchorEl} onClose={onClose} />;
    }

    // Default: Activity modal (timeslot, timepoint, days, nights)
    return <EditActivityModal cartItem={cartItem} anchorEl={anchorEl} onClose={onClose} />;
}
